import { useEffect } from 'react';

export enum Browser {
  Chrome = 'Chrome',
  Firefox = 'Firefox',
  Safari = 'Safari',
  Edge = 'Edge',
  Opera = 'Opera',
  Unknown = 'Unknown',
}

const SUPPORTED_BROWSERS: readonly Browser[] = [Browser.Chrome, Browser.Safari];

export function detectBrowser(userAgent: string) {
  if (/crios/i.test(userAgent)) return Browser.Chrome;
  if (/fxios/i.test(userAgent)) return Browser.Firefox;
  if (/edgios/i.test(userAgent)) return Browser.Edge;
  if (/opr\//i.test(userAgent)) return Browser.Opera;
  if (/edg/i.test(userAgent)) return Browser.Edge;
  if (/chrome|crmo/i.test(userAgent)) return Browser.Chrome;
  if (/firefox/i.test(userAgent)) return Browser.Firefox;
  if (/safari/i.test(userAgent)) return Browser.Safari;

  return Browser.Unknown;
}

export function useBrowserDetection() {
  const browser = detectBrowser(navigator.userAgent);

  useEffect(() => {
    if (!SUPPORTED_BROWSERS.includes(browser)) {
      window.alert(
        `Your browser (${browser}) is not supported. Please use one of: ${SUPPORTED_BROWSERS.join(
          ', ',
        )}, for the best experience.`,
      );
    }
  }, [browser]);
}
